module.exports = require('path-browserify')
